import React from "react";
import { Modal } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import EventBusyRoundedIcon from "@mui/icons-material/EventBusyRounded";
import { useNavigate } from "react-router-dom";
import { roleBasedRedirection } from "../../utils/helper";
import { useAuth } from "../../hooks/useAuth";
import "../../styles/dialog-premium.css";

interface CalendlyUrlErrorPopupProps {
  open: boolean;
  onClose: () => void;
}

const CalendlyUrlErrorPopup: React.FC<CalendlyUrlErrorPopupProps> = ({
  open,
  onClose,
}) => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleUpdateProfile = () => {
    onClose();
    navigate(roleBasedRedirection(`/update-company-profile/${user?.uId || ""}`));
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      className="premium-modal-root"
      BackdropProps={{ className: "premium-modal-backdrop" }}
      aria-labelledby="calendly-url-error-popup"
    >
      <div className="premium-modal-panel">
        <div className="premium-dialog-header">
          <h2 id="calendly-url-error-popup" className="premium-dialog-title">
            Calendly URL Required
          </h2>
          <button
            type="button"
            className="premium-dialog-close"
            onClick={onClose}
            aria-label="Close"
          >
            <CloseRoundedIcon sx={{ fontSize: 18 }} />
          </button>
        </div>

        <div className="premium-dialog-body premium-dialog-body--with-icon">
          <div className="premium-dialog-icon premium-dialog-icon--warning">
            <EventBusyRoundedIcon />
          </div>
          <div className="premium-dialog-content">
            <p className="premium-dialog-message">
              Please provide a valid Calendly URL to schedule meetings with
              candidates. Update your company profile to add your Calendly link.
            </p>
          </div>
        </div>

        <div className="premium-dialog-footer">
          <button
            type="button"
            className="premium-dialog-btn premium-dialog-btn--cancel"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type="button"
            className="premium-dialog-btn premium-dialog-btn--confirm"
            onClick={handleUpdateProfile}
          >
            Update Profile
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default CalendlyUrlErrorPopup;
